import { Lesson } from '@lessonup/teaching-core';
import { transformServingImage } from '@lessonup/typescript-core/utils';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { lessonStore } from '../../../redux/selectors';
import pageTitle from '../../../utils/pageTitle';
import { ExportLessonPageV2View } from './ExportLessonPageV2View';
import { ExportLessonPageView } from './ExportLessonPageView';

type Props = {
  lessonId: string;
};

export const ExportLessonPage: React.FC<Props> = ({ lessonId }) => {
  const { lessonDetails, lessonId: storeLessonId } = useSelector(lessonStore());

  if (!lessonDetails || storeLessonId !== lessonId) return null;

  const { lesson } = lessonDetails;

  // Render the appropriate view based on lesson version
  const content =
    lessonDetails.version === 'v2' ? (
      <ExportLessonPageV2View teacherPins={lessonDetails.teacherPins || []} lesson={lesson} />
    ) : (
      <ExportLessonPageView pins={lessonDetails.pins || []} lesson={lesson} />
    );

  return (
    <div>
      <LessonPageMetaTags lesson={lesson} />
      {content}
    </div>
  );
};

function LessonPageMetaTags({ lesson }: { lesson: Lesson }) {
  const THUMB_WIDTH = 580;
  const thumbHeight = (THUMB_WIDTH / 16) * 9;
  return (
    <Helmet>
      {lesson.name && <title>{pageTitle(lesson.name)}</title>}
      {lesson.thumbnail && (
        <meta
          property="og:image"
          content={transformServingImage(lesson.thumbnail.url, { width: THUMB_WIDTH, height: thumbHeight })}
        />
      )}
    </Helmet>
  );
}
